import { render, staticRenderFns } from "./EjectionMobileCard.vue?vue&type=template&id=3c9eb442&scoped=true"
import script from "./EjectionMobileCard.vue?vue&type=script&lang=js"
export * from "./EjectionMobileCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9eb442",
  null
  
)

export default component.exports